import { useMutation } from '@tanstack/react-query';
import { setupApiClient } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';
import { useAuth } from '@/contexts/AuthContext';

const deleteAccount = async () => {
  const api = setupApiClient();
  await api.post(apiConfig.routes.customer.delete);
};

export const useDeleteAccount = () => {
  const { logout, handleClearDataUserRemembered } = useAuth();
  return useMutation({
    mutationFn: deleteAccount,
    onSuccess: () => {
      handleClearDataUserRemembered();
      logout();
    },
  });
};
